import * as React from 'react'
import { ResourcesRegistrationShape } from '../../api/api_data_types'

type ResourcesRegistrationsRecordPackagingsProps = {
  record: ResourcesRegistrationShape
}

export default function ResourcesRegistrationsRecordPackagings(props: ResourcesRegistrationsRecordPackagingsProps) {
  const { record } = props
  if (record.packagings.length === 0) {
    return null
  }
  return (
    <table className="table table-sm table-responsive">
      <thead>
        <tr>
          <th colSpan={3}>Emballage</th>
        </tr>
        <tr>
          <th>Antal</th>
          <th>Enhed</th>
          <th>Vare</th>
        </tr>
      </thead>
      <tbody>
        {record.packagings.map(resourcePackaging => (
          <tr key={resourcePackaging.id}>
            <td>{resourcePackaging.amount}</td>
            <td>{resourcePackaging.item.base_unit_of_measure}</td>
            <td>{resourcePackaging.item.no} - {resourcePackaging.item.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
